import { LIST_MEMBERSHIP, USER_LIST_MEMBERSHIP } from 'utils/fieldConstants';
import { useTypeaheadSelectedOptions } from './useTypeaheadSelectedOptions';
import { useListMembershipSelectedOptions } from './useListMembershipSelectedOptions';
import { useConditionState } from '../../../../hooks';

export const useMultiSelectSelectedOptions = () => {
  const [{ field }] = useConditionState();
  const typeAheadOptionValues = useTypeaheadSelectedOptions();
  const listMembershipSelectedOptions = useListMembershipSelectedOptions();

  switch (field) {
    case USER_LIST_MEMBERSHIP:
    case LIST_MEMBERSHIP:
      return listMembershipSelectedOptions;
    default:
      return typeAheadOptionValues;
  }
};
